// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NodeIndexOutlinedSvg from "@ant-design/icons-svg/es/asn/NodeIndexOutlined";
import AntdIcon from '../components/AntdIcon';

var NodeIndexOutlined = function NodeIndexOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: NodeIndexOutlinedSvg
  }));
};

NodeIndexOutlined.displayName = 'NodeIndexOutlined';
export default React.forwardRef(NodeIndexOutlined);